<div [class]="tabsClasses()" class="v-one-tabs-transparent">
  <mat-tab-group
    [selectedIndex]="selectedIndex()"
    [disableRipple]="true"
    [animationDuration]="'300ms'"
    [dynamicHeight]="dynamicHeight()"
    (selectedTabChange)="onTabChanged($event)"
    class="v-one-tabs__mat-group"
  >
    @for (tab of tabs(); track tab.id) {
      @if (!tab.lazyLoad) {
        <mat-tab [disabled]="isTabDisabled(tab)" [attr.data-tab-id]="tab.id">
          <ng-template mat-tab-label>
            <span class="v-one-tabs__tab-text">{{ tab.label }}</span>
          </ng-template>
          <ng-container *ngTemplateOutlet="tab.content"></ng-container>
        </mat-tab>
      }
      @if (tab.lazyLoad) {
        <mat-tab [disabled]="isTabDisabled(tab)" [attr.data-tab-id]="tab.id">
          <ng-template mat-tab-label>
            <span class="v-one-tabs__tab-text">{{ tab.label }}</span>
          </ng-template>
          <ng-template matTabContent>
            <ng-container *ngTemplateOutlet="tab.content"></ng-container>
          </ng-template>
        </mat-tab>
      }
    }
  </mat-tab-group>
</div>
